var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('part1',{attrs:{"bannerPath":_vm.partData.bannerPath}}),_c('part2',{attrs:{"projectData":_vm.ProjectData}}),_c('part3',{attrs:{"participatePath":_vm.partData.participatePath}}),_c('part6',{attrs:{"projectData":_vm.ProjectData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }